export default __webpack_public_path__ + "static/media/DSCN6146_1 (2) (1).11f18b0f.jpg";